import React from 'react';
import Navbar from './Navbar';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import './Layout.css';

export default function Layout({ children }) {
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const variants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  };

  const handleSubscribe = async (e) => {
  e.preventDefault();
  if (loading) return;

  setLoading(true);
  setStatus('');

  try {
    await fetch(
      'https://script.google.com/macros/s/AKfycbx_iHKKjSx-0wK3pZ1EHcR4VQ4aTc5R555hTlAj-5gdENxgvH8HDwDlwj497-CYhsA8Ew/exec',
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: new URLSearchParams({ email }).toString()
    });

    // no-cors = you can't read the response, so assume success
    setStatus('Thanks for subscribing!');
    setEmail('');

    } catch (err) {
      setStatus('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Navbar />

      <main style={{ minHeight: '80vh', padding: '2rem 1rem' }}>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            variants={variants}
            initial="initial"
            animate="animate"
            exit="exit"
            transition={{ duration: 0.5 }}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </main>

      <footer className="site-footer">
        <div className="footer-grid">

          {/* COLUMN 1 — BRAND */}
          <div className="footer-col">
            <h4>Life Long Learners</h4>
            <p className="footer-muted">
              Free, accessible tutoring and educational initiatives for students.
            </p>
            <p className="footer-muted">
              © {new Date().getFullYear()} Life Long Learners
            </p>
          </div>

          {/* COLUMN 2 — LINKS */}
          <div className="footer-col">
            <h4>Connect With Us</h4>
            <a href="https://www.facebook.com/share/g/1BD6od4DMB/" target="_blank" rel="noreferrer">Facebook</a>
            <a href="https://www.instagram.com/lifelonglearners.yeg" target="_blank" rel="noreferrer">Instagram</a>
            <a href="https://ca.linkedin.com/company/lifelonglearners-yeg" target="_blank" rel="noreferrer">LinkedIn</a>
            <a href="mailto:lifelonglearners.info@gmail.com">lifelonglearners.info@gmail.com</a>
          </div>

          {/* COLUMN 3 — NEWSLETTER */}
          <div className="footer-col footer-newsletter">
            <div className="newsletter-box">
              <div className="newsletter-title">Newsletter</div>

              <form onSubmit={handleSubscribe}>
                <input
                  type="email"
                  required
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button type="submit" disabled={loading}>
                  {loading ? 'Submitting…' : 'Subscribe'}
                </button>
              </form>

              {status && <p className="status">{status}</p>}

              <p className="casl-note">
                We’ll only send Life Long Learners updates. Unsubscribe anytime by emailing us.
              </p>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <a
            href="https://www.linkedin.com/in/sanaabhaidani/"
            target="_blank"
            rel="noreferrer"
            className="dev-credit"
          >
            Website by Sanaa Bhaidani
          </a>
        </div>
      </footer>

    </>
  );
}
